<template>
  <b-modal
    ref="modal-warning"
    dialog-class="modal-default modal-middle"
    size="md"
    hide-footer
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    @hidden="onClose"
    hide-header
  >
    <!-- <div v-for="(item, index) in warningMessages" :key="index">
      {{ item.message[$i18n.locale] }}
    </div> -->
    <div slot="default">
      <div class="row justify-content-center mt-3">
        <div class="col-10">
          <div class="p-3">
            <div class="card-title fs-16 text-center">
              {{ title }}
            </div>
            <div class="fs-14 lh-1 mb-3 text-center">
              <div v-for="(message, index) in warningMessages" :key="index">
                {{ message }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="row justify-content-center mb-4">
            <div class="col-6">
              <div
                class="btn btn-on btn-default fs-18 fw-light w-100"
                @click="onClose()"
              >
                ตกลง
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </b-modal>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
    warningMessages: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {}
  },
  watch: {
    show: function (value) {
      if (value) {
        this.$refs['modal-warning'].show()
      }
    },
  },
  methods: {
    onClose() {
      this.$refs['modal-warning'].hide()
      this.$emit('hidden')
    },
  },
}
</script>
<style scoped>
.fs-18 {
  font-size: 18px !important;
}
.fw-light {
  font-weight: 300;
}
.btn.btn-default,
.btn.btn-default:hover,
.btn.btn-default:focus {
  line-height: 16px !important;
  padding: 7px 0px !important;
}
.btn-on {
  min-height: 32px;
  cursor: pointer;
  color: #fff;
  text-align: center;
  border: none;
  /* padding: 4px 0px !important; */
  background: -webkit-linear-gradient(#01a0df, #0148cd);
  background: -moz-linear-gradient(#01a0df, #0148cd);
  background: -o-linear-gradient(#01a0df, #0148cd);
  background: linear-gradient(#01a0df, #0148cd);
  background-size: 1px 60px;
  border-radius: 4px;
  -webkit-transition: background 0.3s ease-out;
  -moz-transition: background 0.3s ease-out;
  -o-transition: background 0.3s ease-out;
  transition: background 0.3s ease-out;
}
.btn.btn-on:hover,
.btn.btn-on:focus {
  color: #fff;
  background-position: 10px;
  border: none !important;
}
</style>
